import SecureRandom from "@/util/SecureRandom";

export default class Chunking {

    public fileSize: number;
    public static chunkSize: number = 25000; // in KB, set to 25MB
    private generatedChunkIds: string[] = [];

    constructor(filesize: number) {
        this.fileSize = filesize; // in Bytes
    }

    public calculateChunkCount(): number {
        return Math.ceil(this.fileSize / this.calculateChunkSize());
    }

    public getChunkBeginning(index: number) {
        return index * this.calculateChunkSize();
    }

    public getChunkEnd(index: number): number {
        const end: number = this.getChunkBeginning(index) + (this.calculateChunkSize() - 1);
        const lastPosition: number = this.fileSize - 1;
        return (end > lastPosition ? lastPosition : end); // Out of bounds check
    }

    public getChunkSize(index: number): number {
        const beginning: number = this.getChunkBeginning(index);
        const end: number = this.getChunkEnd(index);
        return (end - beginning) + 1;
    }

    public calculateChunkSize(): number {
        return Chunking.chunkSize * 1000; // Convert kb to bytes
    }

    public generateOrGetChunkIds(): string[] {
        const count: number = this.calculateChunkCount();
        if (this.generatedChunkIds.length !== count) {
            this.generatedChunkIds = [];
            for (let i = 0; i < count; i++) {
                this.generatedChunkIds[i] = SecureRandom.getUUID();
            }
        }
        return this.generatedChunkIds;
    }
}
